/**

Copyright (c) 2018, MOBICOOP. All rights reserved.
This project is dual licensed under AGPL and proprietary licence.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program. If not, see gnu.org/licenses.

Licence MOBICOOP described in the file
LICENSE
**************************/

<template>


        <div class="mc-form-register">

          <div class="mc-form-register-input">

            <ion-grid class="ion-no-margin">
              <ion-row>
                <ion-col size="4">
                  <ion-item>
                    <ion-label position="stacked">{{$t('Register.indicatif')}} *</ion-label>
                    <ion-select :value="user.phoneCode" @ionChange="user.phoneCode = Number($event.target.value);" :cancel-text="'Annuler'" style="font-size: 14px;">
                      <ion-select-option v-for="indicatif in indicatifs" v-bind:value="indicatif.value" >
                        <div><span :class="'fi fi-' + indicatif.country"></span> {{indicatif.code}}</div>
                      </ion-select-option>
                    </ion-select>
                  </ion-item>
                </ion-col>
                <ion-col size="8">
                  <ion-item>
                    <ion-label position="stacked">{{$t('Register.phone')}} *</ion-label>
                    <ion-input
                      type="text"
                      name="telephone"
                      :value="user.telephone"
                      @input="user.telephone = $event.target.value;"
                      @ionChange="checkedPhoneNumber = null;"
                      @ionBlur="checkedPhoneNumber = null;"
                      :placeholder="$t('Register.phone')"
                    ></ion-input>
                    <ion-icon
                      style="margin-top: 16px"
                      slot="end"
                      size="large"
                      color="primary"
                      class="rotating"
                      v-if="this.$store.state.registerStore.statusCheckPhoneNumberValidity == 'loading'"
                      name="sync"
                    ></ion-icon>
                  </ion-item>
                  <div v-if="v$.user.telephone.$error">
                    <div class="mc-error-label"  v-if="v$.user.telephone.required.$invalid">{{$t('Validation.required')}}</div>
                    <div class="mc-error-label" v-if="v$.user.telephone.checkPhoneNumberValidity.$invalid">{{ this.$store.state.registerStore.checkPhoneNumberValidityMessage }}</div>
                  </div>
                </ion-col>
              </ion-row>
            </ion-grid>



            <ion-item v-on:click="goGeoSearch('register_address', 'search')">
              <ion-label position="stacked">{{$t('Register.address')}} *</ion-label>
              <ion-input
                type="text"
                name="address"
                :value="displayAddress"
                readonly="true"
                class="no-clickable ellipsis"
                v-bind:placeholder="$t('Register.address')"
              ></ion-input>
            </ion-item>
            <div v-if="v$.user.addresses.$error">
              <div class="mc-error-label"  v-if="v$.user.addresses.required.$invalid">{{$t('Validation.required')}}</div>
              <div class="mc-error-label"  v-if="v$.user.addresses.fullAddress.$invalid">{{$t('Register.fullAddress')}}</div>
            </div>
            <br>

            <ion-item>
              <ion-label position="stacked">{{$t('Register.gender')}} <span v-if="genderRequired">*</span></ion-label>
              <ion-select
                required
                :value="user.gender"
                @ionChange="user.gender = Number($event.target.value)"
                :cancel-text="$t('Commons.cancel')"
                :placeholder="$t('Register.gender')"
              >
                <ion-select-option v-if="genderNC" value="3">{{$t('Register.nc')}}</ion-select-option>
                <ion-select-option value="2">{{$t('Register.male')}}</ion-select-option>
                <ion-select-option value="1">{{$t('Register.female')}}</ion-select-option>
              </ion-select>
            </ion-item>
            <div v-if="v$.user.gender.$error">
              <div class="mc-error-label"  v-if="v$.user.gender.required.$invalid">{{$t('Validation.required')}}</div>
            </div>

            <ion-item v-if="askBirthdate">
              <ion-label>{{ $t('Register.birthDate') }} <span v-if="requiredBirthdate">*</span></ion-label>
              <ion-datetime-button slot="end" datetime="datePickerRegister"></ion-datetime-button>
              <ion-modal :keep-contents-mounted="true">
              <ion-datetime
                display-format="DD/MM/YYYY"
                picker-format="DD/MM/YYYY"
                presentation="date"
                :show-default-buttons="true"
                :cancel-text="$t('Commons.cancel')"
                :done-text="$t('Commons.validate')"
                :value="user.birthDate.toString()"
                :first-day-of-week="1"
                :max="now"
                @ionChange="user.birthDate = $event.detail.value; checkBirthdate()"
                id="datePickerRegister"
              ></ion-datetime>
              </ion-modal>
            </ion-item>
            <div v-if="v$.user.birthDate.$error">
              <div class="mc-error-label"  v-if="v$.user.birthDate.required.$invalid">{{$t('Validation.required')}}</div>
              <div class="mc-error-label"  v-if="v$.user.birthDate.isMaxBirthDate.$invalid">{{$t('Validation.age', { value: minAge })}}</div>
            </div>

            <div v-if="needParentalConsent">
              <ion-item>
                <ion-label position="stacked">{{$t('Register.legal')}} *</ion-label>
                <ion-input
                  type="email"
                  :placeholder="$t('Register.legal') + '*'"
                  :value="user.legalGuardianEmail"
                  @input="user.legalGuardianEmail = $event.target.value"
                ></ion-input>
              </ion-item>
              <div class="ion-text-start legal-desc">
                {{$t('Register.legalDesc')}}
             </div>
              <div v-if="v$.user.legalGuardianEmail.$error">
                <div class="mc-error-label" v-if="v$.user.legalGuardianEmail.required.$invalid">{{$t('Validation.required')}}</div>
                <div class="mc-error-label" v-if="v$.user.legalGuardianEmail.email.$invalid">{{$t('Validation.email')}}</div>
              </div>
            </div>

            <div class="mc-select-communities text-left" v-if="showCommunities">
              <ion-spinner v-if="loadingCommunities" margin-top name="crescent" class="mc-st-loading-spinner"></ion-spinner>
              <ion-item v-if="this.communities.length > 0" class="item-communities" v-on:click="goSelectCommunity(); $event.preventDefault(); $event.stopPropagation();">
                <ion-label position="stacked">{{$t('Register.community')}} <span v-if="neededCommunities">*</span></ion-label>
                <ion-select
                  placeholder="Sélectionnez une communauté"
                  interface="none"
                  style="pointer-events: none"
                  multiple="true"
                >
                  <ion-select-option
                    v-for="community in communities"
                    :key="community.id"
                    :value="community.id"
                    v-bind:selected="user.communityId.includes(community.id)"
                  >{{ community.name }}</ion-select-option>
                </ion-select>
              </ion-item>
              <div v-if="v$.user.communityId.$error">
                <div class="mc-error-label"  v-if="v$.user.communityId.required.$invalid">{{$t('Validation.required')}}</div>
              </div>
            </div>
            <br>
            <ion-item lines="none">
              <ion-checkbox
                name="userAgreementAccepted"
                :value="user.userAgreementAccepted"
                color="success"
                slot="start"
                @ionChange="changeUserAgreementAccepted($event)"
                :checked="user.userAgreementAccepted"
              ></ion-checkbox>
              <ion-label class="no-white-space"><p>{{ $t('Register.userAgreementAccepted') }}</p></ion-label>
            </ion-item>
            <div v-if="v$.user.userAgreementAccepted.$error">
              <div class="mc-error-label"  v-if="v$.user.userAgreementAccepted.checked.$invalid">{{$t('Validation.required')}}</div>
            </div>
            <div v-if="instance == 'sncf'">
              <ion-item lines="none">
                <ion-checkbox
                  name="proVoitureur"
                  :value="user.proVoitureur"
                  color="success"
                  slot="start"
                  @ionChange="changeProVoitureur($event)"
                  :checked="user.proVoitureur"
                ></ion-checkbox>
                <ion-label class="no-white-space"><p>{{ $t('Register.proVoitureur') }}</p></ion-label>
              </ion-item>
              <div v-if="v$.user.proVoitureur.$error">
                <div class="mc-error-label"  v-if="v$.user.proVoitureur.checked.$invalid">{{$t('Validation.required')}}</div>
              </div>
            </div>



            <br>
            <a class="text-center pointer" v-on:click="goToCgu()">{{ $t('Register.conditions') }}</a>
            <a class="text-center pointer mt-10" v-if="instance == 'sncf'" v-on:click="goToSncfCharte()">Voir la charte</a>
            <a class="text-center pointer mt-10" v-if="hasProtection()" v-on:click="goToProtection()">Voir la politique de confidentialité</a>

            <br>
            <div class="text-asterisk text-left"><small>* Champ obligatoire</small></div>

            <br>
            <ion-button v-if="instance == 'mobicoop'"  class='mc-small-button' color="primary" expand="block" fill="outline" @click="goToRezoPouce()">
              PLUTÔT REZO POUCE ?
            </ion-button>

          </div>

        </div>

</template>

<style lang="scss">

  .no-white-space {
    white-space: normal !important;
  }
  .mc-form-register {
    display: block;
    height: 100%;
    flex-direction: column;
    justify-content: space-between;

    .mc-form-register-input {
      flex: 1;
      flex-direction: column;
      display: flex;
      justify-content: center
    }
  }

  .text-asterisk {
    font-size: 14px;
    color: rgba(0,0,0,0.4)
  }

  .legal-desc {
    font-size: 12px;
    line-height: 15px;
    margin-top: 8px;
  }

</style>

<script>
import {required, email, sameAs, minLength, requiredIf, helpers} from '@vuelidate/validators'
  import useVuelidate from "@vuelidate/core";
  var moment = require('moment');

const { withAsync } = helpers

function checkPhoneNumberValidityValidator(telephone) {
  if (!this.checkedPhoneNumber) {
    this.checkedPhoneNumber = this.$store.dispatch('checkPhoneNumberValidity', '+' + this.user.phoneCode + (telephone.charAt(0) === "0" ? telephone.substring(1) : telephone))
    return this.checkedPhoneNumber.then(res => {
      return res
    })
  } else {
    return this.checkedPhoneNumber.then(res => {
      return res
    })
  }
}


    const checked = value => value === true;


    const isMaxBirthDate = (value, vm) => {
      if (JSON.parse(process.env.VUE_APP_REQUIRED_BIRTHDATE)) {
        let n = new Date();
        n.setFullYear(n.getFullYear() - process.env.VUE_APP_REGISTER_MIN_AGE);
        return moment(value).isBefore(moment(n.toISOString()));
      } else {
        return true;
      }
    }


    export default {
        name: 'registerStep2',
        setup () {
          return { v$: useVuelidate() }
        },
        data () {
            return {
                instance: process.env.VUE_APP_INSTANCE,
                maxBirthDate: this.getMaxBirthDate(),
                minAge: process.env.VUE_APP_REGISTER_MIN_AGE,
                minorAge: 18,
                askBirthdate: JSON.parse(process.env.VUE_APP_ASK_BIRTHDATE),
                requiredBirthdate: JSON.parse(process.env.VUE_APP_REQUIRED_BIRTHDATE),
                parentalConsentActivated: JSON.parse(process.env.VUE_APP_PARENTAL_CONSENT),
                showCommunities: JSON.parse(process.env.VUE_APP_REGISTER_COMMUNITY),
                neededCommunities: JSON.parse(process.env.VUE_APP_REGISTER_COMMUNITY_NEEDED),
                genderRequired: JSON.parse(process.env.VUE_APP_GENDER_REQUIRED),
                fullAddressRequired: JSON.parse(process.env.VUE_APP_REGISTER_FULL_ADDRESS),
                genderNC: JSON.parse(process.env.VUE_APP_GENDER_NC),
                userAgreementAccepted: false,
                indicatifs: JSON.parse(process.env.VUE_APP_PHONE_IND),
                communities: [],
                loadingCommunities: false,
                checkedPhoneNumber: null,
                popoverOptions: {showBackdrop: false},
                now: new Date().toISOString(),
                needParentalConsent: false
            }
        },
        validations() { return {
            user: {
                phoneCode: {
                  required,
                },
                telephone: {
                    required,
                    checkPhoneNumberValidity: withAsync(checkPhoneNumberValidityValidator)
                },
                addresses: {
                    required,
                    fullAddress(address) {
                      return this.fullAddressRequired ? (address[0] ? (address[0].type === "housenumber" || address[0].type === "street" )  : false) : true;
                    }
                },
                gender: {
                    required : requiredIf(function () {
                      return this.genderRequired;
                    }),
                },
                birthDate: {
                    required :  requiredIf(function () {
                      return this.requiredBirthdate;
                    }),
                    isMaxBirthDate
                },
                legalGuardianEmail: {
                  required :  requiredIf(function () {
                    return this.needParentalConsent && this.parentalConsentActivated;
                  }),
                  email
                },
                userAgreementAccepted: {
                    required,
                    checked
                },
                proVoitureur: {
                  required :  requiredIf(function () {
                    return this.instance == 'sncf'
                  }),
                  checked(proVoitureur) {
                    return this.instance === 'sncf' ? proVoitureur === true : true;
                  }
                },
                communityId: {
                  required :  requiredIf(function () {
                    return this.neededCommunities;
                  }),
                }
            }
        }},
        computed: {
          Datetime() {
            return Datetime
          },
            user : {
                get() {
                    return this.$store.state.registerStore.userToRegister
                },
                set() {
                    this.$store.commit('register_update', this.user);
                }
            },
            displayAddress : {
                get() {
                    return this.$store.state.registerStore.displayAddress
                }
            },
        },
        created() {

          if (!this.user.communityId) {
            this.user.communityId = []
          }

          if (!this.user.phoneCode) {
            this.user.phoneCode = this.indicatifs[0].value
          }

          if (this.showCommunities) {
            this.loadingCommunities = true;
            this.$store.dispatch('getAllCommunities', {query: '', number: 1000}).then(res => {
              this.communities = res.data['hydra:member']
              this.loadingCommunities = false;
            }).catch(() => {
              this.loadingCommunities = false;
            })
          }
        },
        methods: {
            getMaxBirthDate() {
              let n = new Date();
              n.setFullYear(n.getFullYear() - process.env.VUE_APP_REGISTER_MIN_AGE);
              return n.toISOString();
            },
            goGeoSearch(type, action) {
                this.$router.push({ name: "geoSearch", query: { type, action, fullAddressRequired: this.fullAddressRequired }});
            },
            goSelectCommunity() {
              this.$router.push({ name: "selectCommunity" });
            },
            async validate() {
                await this.v$.$reset();
                await this.v$.$touch();
                await this.v$.$validate();
                if (this.v$.$invalid) {
                    return false;
                } else {
                    return true;
                }
            },
            changeUserAgreementAccepted(event) {
                event.detail.checked ? ( this.user.userAgreementAccepted = true) : (this.user.userAgreementAccepted = false);
            },
            changeProVoitureur(event) {
              event.detail.checked ? ( this.user.proVoitureur = true) : (this.user.proVoitureur = false);
              this.user = this.user;
            },
            setCommunities(event) {
              this.user.communityId = event.detail.value;
            },
            hasProtection() {
              const t = this.$t("Contact.protection-external-link");
              return t !== "Contact.protection-external-link";
            },
            goToProtection() {
              const t = this.$t("Contact.protection-external-link");
              window.open(t, '_blank');
            },
          goToSncfCharte() {
            window.open(this.$t("Link.charte"), '_blank');
          },
            goToRezoPouce() {
              this.$router.push({name:'hitchHiking.register', query: {step: 1}});
            },
            goToCgu() {
              if (this.instance == 'sncf') {
                window.open(this.$t("Link.cgu"), '_blank');
              } else {
                this.$router.push('/article/1')
              }
            },
          checkBirthdate() {
            let minAge = new Date();
            minAge.setFullYear(minAge.getFullYear() - this.minAge);
            let legalAge = new Date();
            legalAge.setFullYear(legalAge.getFullYear() - this.minorAge);
            const res = moment(this.user.birthDate).isBefore(moment(minAge.toISOString())) && moment(this.user.birthDate).isAfter(moment(legalAge.toISOString()));
            if (this.parentalConsentActivated && res) {
              this.needParentalConsent = true
            } else {
              this.needParentalConsent = false
            }
          }
        }
    }
</script>
